module.exports = __webpack_public_path__ + "static/media/infographicsicon.6f27f06f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/infographicsicon.svg
// module id = 1722
// module chunks = 0